import { useRef } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';
import { upload } from 'hb-builder/utils/files';
import type { OldBuilderActionsHeaderProps } from 'hb-react/backoffice/components/BuilderWrapper/components/Actions/OldBuilderActionsHeader';

export const ACCEPT_BUILDER_DOCUMENT = ['text/plain;charset=utf-8'];

interface UploadProps {
  authIds: AuthenticationIds;
  uploadDocument: OldBuilderActionsHeaderProps['saveDocument'];
}

const Upload = ({ authIds, uploadDocument }: UploadProps) => {
  const fileRef = useRef<HTMLInputElement>(null);

  const handleClick = () => fileRef.current?.click();

  const handleInputFile = (e) => {
    const [file] = e.target.files;

    if (file) {
      upload({
        authIds,
        file,
        callback: (document) => uploadDocument({ document }),
      });
    }
  };

  return (
    <Wrapper>
      <Box flexDirection="column">
        <InputTitle
          label={s__('Builder|Upload JSON document')}
          position="left"
        />
        <Description>
          {s__(
            "Builder|This feature is dedicated to reproduce customers' bugs.",
          )}
        </Description>
        <Description>
          {s__('Builder|Do not use to duplicate a page.')}
        </Description>
      </Box>
      <Button
        aria-label={s__('Builder|Upload JSON document')}
        icon={() => (
          <FontAwesomeIcon
            iconName="arrow-up-to-line"
            iconType={CATEGORIES.SOLID}
            height="12px"
          />
        )}
        onClick={handleClick}
        variant="secondary"
      />

      <InputStyled
        accept={ACCEPT_BUILDER_DOCUMENT.toString()}
        data-testid="upload-component-input-file"
        onChange={handleInputFile}
        ref={fileRef}
        type="file"
      />
    </Wrapper>
  );
};

export default Upload;

const Description = styled(Box).attrs(() => ({
  color: 'dove',
  mt: 1,
}))``;

const InputStyled = styled.input`
  position: absolute;
  top: 0;
  visibility: hidden;
`;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  mb: 4,
  justifyContent: 'space-between',
  width: '100%',
}))``;
